import { http } from "../base"


export async function countDashboard(tenantId) {
    console.log("countDashboard",tenantId);
    try {
        const response = await http.get(
            `/aics/dashboard/count_by_tenant?tenantId=${tenantId}&userName=`
        );
        return response;
    } catch (error) {
        return error;
    }
}



